import { ethers } from 'ethers';
import {
  OrionToLumiaConverter,
  OrionToLumiaConverter__factory,
} from '@orionprotocol/contracts/lib/ethers-v6';
import { useContract } from '@orionprotocol/utils';

export function useOrionToLumiaConverterContract(
  address: string | undefined,
  signerOrProvider: ethers.Signer | ethers.Provider | undefined,
): OrionToLumiaConverter | undefined {
  const orionToLumiaConverterContract = useContract(
    address,
    signerOrProvider,
    OrionToLumiaConverter__factory,
  );

  return orionToLumiaConverterContract;
}
